import upgradePlanStore from 'src/Modals/UpgradePlanModal/store/upgradePlanStore'

export const openUpgradePlanModal = () =>
  upgradePlanStore.setOpenUpgradePlanModal(true)
